module.exports = __webpack_public_path__ + "img/dismiss_icon.7a76b2bf.png";